<template>
  <div>
    <div
      v-for="(section, index) in survey.sections"
      :key="`section-${section.id}`"
    >
      <Collapsible v-if="displayCollapsible" v-model:open="sectionOpenStatus[index]">
        <CollapsibleTrigger as-child>
          <div class="flex flex-row justify-between items-center mb-4 hover:opacity-80">
            <h2
              v-if="section?.title"
              class="text-lg"
            >
              {{ section.title }}
            </h2>
            <ChevronUp v-if="sectionOpenStatus[index]" class="text-primary" />
            <ChevronDown v-else class="text-primary" />
          </div>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <SurveySectionView
            :editable="editable"
            :survey="survey"
            :section="section"
            :density="density"
            :answers="answers"
            :errors="errors"
            :reasons="reasons"
            @on-change="({label, questionId}) => onChange(label, questionId)"
          />
        </CollapsibleContent>
      </Collapsible>
      <div v-else>
        <h2
          v-if="section?.title"
          class="text-lg"
        >
          {{ section.title }}
        </h2>
        <SurveySectionView
          :editable="editable"
          :survey="survey"
          :section="section"
          :answers="answers"
          :density="density"
          :errors="errors"
          :reasons="reasons"
          @on-change="({label, questionId}) => onChange(label, questionId)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {Survey} from "@/core/interfaces/survey/Survey";
import {ref} from "vue";
import {Collapsible, CollapsibleContent, CollapsibleTrigger} from "@/core/components/ui/collapsible";
import SurveySectionView from "@/survey/components/SurveySectionView.vue";
import {ChevronDown, ChevronUp} from "@lucide/vue";


const {survey, answers = null, errors = null, reasons = null, density = 'normal', displayCollapsible = false, editable = true} = defineProps<{
    survey: Survey;
    answers?: Record<number, (string | number | boolean | undefined)[]> | null;
    errors?: Record<number, string | undefined> | null;
    /** Prefill explanations by question id. */
    reasons?: Record<number, string> | null;
    density?: 'compact' | 'normal';
    displayCollapsible?: boolean;
    editable?: boolean;
}>();

const emits = defineEmits<{
    (e: 'change', payload: {value: unknown, questionId: number}): void;
}>();

const sectionOpenStatus = ref(survey.sections?.map((_, index) => index === 0) ?? [false]);

const onChange = (value: any, questionId: number) => {
    emits('change', {value, questionId});
};
</script>
